export class StopPlaceRevertFailed extends AggregateError {}
